import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Calendar, Medal } from 'lucide-react';

export default function SeasonCountdown() {
  const [season, setSeason] = useState(null);
  const [awards, setAwards] = useState([]);

  useEffect(() => {
    api.get('/seasons/current').then(r => setSeason(r.data)).catch(() => {});
    api.get('/seasons/awards?limit=6').then(r => setAwards(r.data.awards || [])).catch(() => {});
  }, []);

  if (!season) return null;

  return (
    <div className="mt-10 border border-[#2B3139] bg-[#181A20] p-5" data-testid="season-countdown">
      <div className="flex items-center gap-2 mb-3">
        <Calendar className="w-5 h-5 text-[#FCD535]" />
        <h2 className="text-white text-lg font-semibold">Season {season.season_id + 1}</h2>
        <span className="text-xs uppercase tracking-wider text-[#848E9C]">every 4 weeks · top 3 get permanent badges</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="border border-[#2B3139] bg-[#0B0E11] p-3">
          <div className="text-xs uppercase text-[#848E9C]">Ends in</div>
          <div className="font-mono text-white text-2xl mt-1">{season.days_remaining}<span className="text-sm text-[#848E9C] ml-1">days</span></div>
        </div>
        <div className="border border-[#FCD535]/30 bg-[#FCD535]/8 p-3" data-testid="season-prize-pool">
          <div className="text-xs uppercase text-[#FCD535]">Prize Pool · Sponsored</div>
          <div className="font-mono text-[#FCD535] text-2xl mt-1">{Math.round(season.total_prize_pool || 0).toLocaleString()}<span className="text-xs ml-1">USDT</span></div>
          <div className="text-[10px] text-[#B7BDC6] mt-1 flex gap-2">
            <span>🥇 {Math.round(season.prizes?.["1"] || 0)}</span>
            <span>🥈 {Math.round(season.prizes?.["2"] || 0)}</span>
            <span>🥉 {Math.round(season.prizes?.["3"] || 0)}</span>
          </div>
        </div>
        <div className="border border-[#2B3139] bg-[#0B0E11] p-3">
          <div className="text-xs uppercase text-[#848E9C]">Winners so far</div>
          <div className="font-mono text-white text-2xl mt-1">{awards.length}</div>
        </div>
      </div>
      {awards.length > 0 && (
        <div className="mt-4">
          <div className="text-xs uppercase tracking-wider text-[#848E9C] mb-2 flex items-center gap-1"><Medal className="w-3.5 h-3.5" /> Hall of Fame</div>
          <div className="flex flex-wrap gap-2">
            {awards.slice(0, 12).map(a => (
              <a key={a.award_id} href={`/trader/${a.user_id}`}
                className="flex items-center gap-1.5 border border-[#FCD535]/30 bg-[#FCD535]/8 px-2 py-1 rounded-sm text-xs text-[#EAECEF] hover:border-[#FCD535]"
                data-testid={`hof-${a.award_id}`}>
                <span>{a.place === 1 ? '🥇' : a.place === 2 ? '🥈' : '🥉'}</span>
                <span className="font-mono text-[#FCD535]">S{a.season_id + 1}</span>
                <span className="text-[10px] text-[#B7BDC6]">·</span>
                <span className="font-mono text-[10px] text-[#B7BDC6]">{(a.user_id || '').slice(-6)}</span>
                <span className="text-[10px] text-[#F6465D] font-mono">{a.streak_at_award}🔥</span>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
